export default "__VITE_ASSET__J1XkNO75__"